import angular from 'angular'

import formWidgetModule from './formWidget/formWidget'

export default angular.module('app.common.dynamicForm.widgets', [
  formWidgetModule.name,
])
